document.querySelectorAll('.social-media-trigger').forEach(trigger => {
    const list = trigger.nextElementSibling;
    if (list) {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            list.classList.toggle('is-hidden')
            trigger.classList.toggle('is-active')
        });
    }

});
